import React from "react";
import { Typography } from "@mui/material";

interface Props {
  title: string | null;
  value: string | null;
  titleStyle?: React.CSSProperties;
  valueStyle?: React.CSSProperties;
  rootStyle?: React.CSSProperties;
}

function CustomKeyValue({
  title,
  value,
  titleStyle,
  valueStyle,
  rootStyle,
}: Props) {
  return (
    <div style={{ ...rootStyle }}>
      <Typography sx={{ color: "#757575", fontSize: 12, ...titleStyle }}>
        {title}
      </Typography>
      <Typography sx={{ ...valueStyle}}>{value}</Typography>
    </div>
  );
}

export default CustomKeyValue;
